import { NavLink } from "react-router-dom";
import { Users, UserPlus, Building2, BookOpen } from "lucide-react";

/**
 * Sticky funnel tabs shown at the top of Contacts / Leads / Clients pages.
 * Marketing Contact → Lead → Client is one customer journey, this lets the
 * rep flip between the three stages with a single tap. "All Contacts" sits
 * at the end as a unified read-only roll-up across every contact source.
 */
const TABS = [
  { to: "/leads", label: "Leads", icon: UserPlus, hint: "Warm · in conversation" },
  { to: "/clients", label: "Users", icon: Building2, hint: "Hot · active accounts" },
  { to: "/all-contacts", label: "All", icon: BookOpen, hint: "Unified roll-up" },
];

export default function CustomersTabs() {
  return (
    <div className="-mx-5 sm:-mx-8 lg:-mx-10 mb-5 sm:mb-6" data-testid="customers-tabs">
      <div className="px-5 sm:px-8 lg:px-10">
        <div className="rounded-2xl border border-border/60 bg-muted/30 p-1 grid grid-cols-3 gap-1">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              data-testid={`customers-tab-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                `tap rounded-xl px-2 py-2 text-center transition ${
                  isActive
                    ? "bg-primary text-primary-foreground shadow-soft"
                    : "text-muted-foreground hover:bg-muted/60 hover:text-foreground"
                }`
              }
            >
              {({ isActive }) => (
                <div className="flex flex-col items-center gap-0.5">
                  <div className="flex items-center gap-1.5">
                    <t.icon className="h-3.5 w-3.5" strokeWidth={2.5} />
                    <span className="text-xs font-bold">{t.label}</span>
                  </div>
                  <span className={`text-[9px] tracking-wide hidden sm:block ${isActive ? "opacity-90" : "opacity-70"}`}>{t.hint}</span>
                </div>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}
